export const ACCOUNT_ISSUER_TYPES = {
  issuer: 121,
};
